module.exports = __webpack_public_path__ + "img/14-ton-drop-side-flat-deck-truck.ce3d0ade.jpg";